const START_BODY_TAG_REGEXP = /<body[^>]*>/i;
const END_BODY_TAG_REGEXP = /<\/body>/i;

const prepareClipboardData = (textHtmlData) => {
  const hasBodyTags =
    textHtmlData.match(START_BODY_TAG_REGEXP) && textHtmlData.match(END_BODY_TAG_REGEXP);

  if (!hasBodyTags) {
    return textHtmlData;
  }

  const firstBodyIndex =
    textHtmlData.search(START_BODY_TAG_REGEXP) +
    textHtmlData.match(START_BODY_TAG_REGEXP)[0].length;
  const lastBodyIndex = textHtmlData.search(END_BODY_TAG_REGEXP);
  const bodyContent = textHtmlData.substring(firstBodyIndex, lastBodyIndex);

  return bodyContent;
};

export default prepareClipboardData;
